// C-04 warnings (UserFlows C-04; mockup `SettingsPage.tsx` `warnings`): shown on the Appointment settings tabs,
// never blocking. No work pattern (D-73): a provider can take a visit type at every shown location.
import { needsRecipients, PF_MESSAGE_COPY } from './pfMessages'
import type { Settings } from './types'

/** The shown providers allowed to take this visit type (all shown providers when `providerIds` is null). */
export function visibleProvidersFor(s: Settings, providerIds: readonly string[] | null) {
  return s.providers.filter((p) => p.visible && (providerIds === null || providerIds.includes(p.id)))
}

const list = (names: string[]) => names.join(', ')

export function warnings(s: Settings): string[] {
  const out: string[] = []
  const dead = s.visitTypes.filter((v) => v.enabled && visibleProvidersFor(s, v.providerIds).length === 0)
  if (dead.length) {
    const one = dead.length === 1
    out.push(
      `${list(dead.map((v) => v.name))} ${one ? 'has' : 'have'} no visible provider, so patients won't see ${one ? 'it' : 'them'}.`,
    )
  }
  const stale = [
    ...s.visitTypes.filter((v) => v.enabled && v.removedInPf).map((v) => v.name),
    ...s.locations.filter((l) => l.visible && l.removedInPf).map((l) => l.name),
    ...s.providers.filter((p) => p.visible && p.removedInPf).map((p) => p.name),
  ]
  if (stale.length) {
    const one = stale.length === 1
    out.push(
      `${list(stale)} no longer ${one ? 'exists' : 'exist'} in Practice Fusion. Bookings for ${one ? 'it' : 'them'} will fail until you turn ${one ? 'it' : 'them'} off.`,
    )
  }
  // Task 24 (C-14): the PF message is on, but nobody (active) would get it.
  if (needsRecipients(s)) out.push(PF_MESSAGE_COPY.noRecipients)
  return out
}
